// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Button, TextField, Typography, Paper, Alert, Link } from '@mui/material';
import api from '../services/api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      await api.post('/password-reset/', { email });
      setSuccess('Se um usuário com este e-mail existir, um link de redefinição foi enviado.');
    } catch (err) {
      setError('Ocorreu um erro ao processar a solicitação.');
      console.error(err.response?.data || err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(to bottom, #F2F5F8, #E6EDF4)' }}>
      <Paper component="form" onSubmit={handleSubmit} elevation={6} sx={{ padding: 4, width: 400, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ marginY: 2, color: '#0D47A1' }}>Esqueci a Senha</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Digite seu e-mail abaixo para receber um link de redefinição de senha.
        </Typography>
        
        {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ my: 2 }}>{success}</Alert>}

        <TextField 
          fullWidth 
          label="Seu Email" 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          margin="normal" 
          required 
        />
        
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, py: 1.5, backgroundColor: '#1565C0' }} disabled={isLoading}>
          {isLoading ? 'Enviando...' : 'Enviar Link'}
        </Button>
        <Link component={RouterLink} to="/login" sx={{ display: 'block', mt: 2 }}>
          Lembrou a senha? Voltar para o Login
        </Link>
      </Paper>
    </Box>
  );
};

export default ForgotPasswordPage;